'use client';

import { Popover } from '@base-ui/react/popover';
import { css } from '@repo/pandacss/styled-system/css';
import { type DriverType } from '@repo/supergraph/marketplace/types';
import React, { useMemo } from 'react';
import { MdHelpOutline } from 'react-icons/md';
import { DisclosureTooltip } from '../../DisclosureTooltip';
import { summaryTableDriverCellTooltipClassName } from '../../disclosureTooltipPopover';

export const DriverCell = ({ driver }: { driver?: DriverType }): React.JSX.Element => {
  const handler = useMemo(() => Popover.createHandle<unknown>(), []);

  const renderValue = ({ driver }: { driver?: DriverType }) => {
    if (!driver?.value && driver?.label === 'Overdraft star rating') {
      return 'Not rated yet';
    }
    if (!driver || !driver?.value) {
      return 'N/A';
    }
    if (driver.label === 'Product type') {
      return driver.value;
    }

    return driver.value?.replace('-', ' -\n');
  };

  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        columnGap: '1',
        rowGap: '1',
      })}
    >
      <div
        className={css({
          lineHeight: '[24px]',
        })}
      >
        <span
          className={css({
            display: 'inline',
          })}
        >
          {renderValue({ driver })}
        </span>
        {driver?.valueTooltip && (
          <span
            className={css({
              display: 'inline',
              whiteSpace: 'nowrap',
            })}
          >
            &nbsp;
            <Popover.Trigger
              handle={handler}
              className={css({
                borderTopStyle: 'none',
                borderRightStyle: 'none',
                borderBottomStyle: 'none',
                borderLeftStyle: 'none',
                backgroundColor: 'transparent',
                paddingTop: '0',
                paddingRight: '0',
                paddingBottom: '0',
                paddingLeft: '0',
                cursor: 'pointer',
                display: 'inline-flex',
                color: 'neutral.black',
              })}
              aria-label={`${driver.label} info`}
            >
              <MdHelpOutline size={14} />
            </Popover.Trigger>
            <DisclosureTooltip
              handler={handler}
              tooltipClassName={summaryTableDriverCellTooltipClassName}
            >
              <span
                className={css({
                  marginTop: '0',
                  marginRight: '0',
                  marginBottom: '0',
                  marginLeft: '0',
                  textAlign: 'left',
                  textStyle: 'textSmall',
                  wordWrap: 'break-word',
                })}
              >
                {driver.valueTooltip}
              </span>
            </DisclosureTooltip>
          </span>
        )}
      </div>
      <div className={css({ fontSize: 'sm', fontWeight: 'normal', lineHeight: '[1.43]' })}>
        {driver?.description && (
          <span
            className={css({
              textStyle: 'textSmall',
              color: 'neutral.dark',
            })}
          >
            {driver.description}
          </span>
        )}
      </div>
    </div>
  );
};
